module.exports = __webpack_public_path__ + "static/media/faqBalance-en-ko.796b1609.vtt";